module.exports = __webpack_public_path__ + "static/media/Chelsey Tanaka.bf7f66c2.png";